import React from 'react';
import {Subtract} from 'utility-types';
import ElementConfiguration from '../../../models/form/ElementConfiguration';
import {LanguageId} from '../../../models/utils/Languages';

interface WithTranslationState {
  translations: LanguageId[]
}

interface WithTranslationsProps {
  defaultLanguage: LanguageId
  configuration?: ElementConfiguration
}

export interface InjectedTranslationsProps {
  translations: LanguageId[]
  onAddTranslation: (langId: LanguageId) => void
  onDeleteTranslation: (langId: LanguageId) => void
}

export default function withTranslations<T extends InjectedTranslationsProps>(Component: React.ComponentType<T>) {
  // eslint-disable-next-line react/display-name
  return class extends React.Component<
    Subtract<T, InjectedTranslationsProps> & WithTranslationsProps,
    WithTranslationState
  > {
    constructor(props: Subtract<T, InjectedTranslationsProps> & WithTranslationsProps) {
      super(props);

      const selectedTranslations = props.configuration ?
        [...new Set(props.configuration.labels.map((x) => x.language).concat([props.defaultLanguage]))] :
        [props.defaultLanguage];

      this.state = {
        translations: selectedTranslations,
      };
    }

    addTranslation = (language: LanguageId) => {
      this.setState((prevState) => ({
        translations: prevState.translations.concat([language]),
      }));
    };

    deleteTranslation = (langId: LanguageId) => {
      this.setState((prevState) => ({
        translations: prevState.translations.filter((x) => x !== langId),
      }));
    }

    render() {
      return <Component
        {...this.props as unknown as T}
        translations={this.state.translations}
        onAddTranslation={this.addTranslation}
        onDeleteTranslation={this.deleteTranslation}
      />;
    }
  };
}
